import { Check, X, AlertCircle } from "lucide-react";

interface ComplianceCheckProps {
  label: string;
  passed?: boolean;
}

export function ComplianceCheck({ label, passed }: ComplianceCheckProps) {
  const getIcon = () => {
    if (passed === undefined) {
      return <AlertCircle className="h-5 w-5 text-gray-400" />;
    }
    return passed ? (
      <Check className="h-5 w-5 text-green-600" />
    ) : (
      <X className="h-5 w-5 text-red-600" />
    );
  };

  const getBgColor = () => {
    if (passed === undefined) return "bg-gray-50";
    return passed ? "bg-green-50" : "bg-red-50";
  };

  return (
    <div
      className={`flex items-center justify-between p-3 rounded-lg ${getBgColor()}`}
    >
      <span className="text-sm text-gray-700">{label}</span>
      {getIcon()}
    </div>
  );
}
